// extracted by mini-css-extract-plugin
export default {"header":"Header__header___4Llwb","ornamental":"Header__ornamental___RG3MO"};